<template>
  <span>
    <v-card v-for="(r, i) in resource.data" :key="'resource-' + i" class="mb-2">
      <v-card-text class="py-0">
        <v-row class="pa-0 px-2 align-center">
          <v-col cols="12" md="2" :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 font-weight-bold`">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div style="font-size:11px;text-transform:uppercase;">label</div>
                <span v-bind="attrs" v-on="on">{{ r.label }}</span>
              </template>
              <div class="text-center">
                <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n.description }}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="12" md="2" :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 font-weight-bold`">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div style="font-size:11px;text-transform:uppercase;">slug</div>
                <span v-bind="attrs" v-on="on">{{ r.slug }}</span>
              </template>
              <div class="text-center">
                <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n.description }}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="12" md="2" :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 mt-0 font-weight-bold`">
            <div style="font-size:11px;text-transform:uppercase;">platform</div>
            {{ r.platform.label }}
          </v-col>
          <v-col cols="12" md="2" :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 mt-0`">
            <v-switch @change="updateResource(r)" hide-details inset :class="`${arabic ? 'arFont' : 'enFont'} mt-0`"
              :name="i18n.active" :label="i18n.active" v-model="r.active"></v-switch>
          </v-col>
          <v-col cols="12" md="3" :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 mt-0`">
          </v-col>
          <v-col cols="12" md="1" :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 mt-0 text-center`">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" x-small @click.stop="edit(r)">
                  <v-icon left size="12">create</v-icon>
                  {{ i18n.editIconTooltip }}
                </v-btn>
              </template>
              <span :class="`${arabic ? 'arFont' : 'enFont'} pa-0`">
                {{ i18n.editIconTooltip }}
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props: ['resourceSettings', 'resource', 'resourceKeys', 'match'],
  methods: {
    openLink(url) {
      window.open(url, '_blank');
    },
    edit(r) {
      this.$emit('editItem', r)
    },
    getFormat(d) {
      return format(d)
    },
    clipboardSuccessHandler({ value, event }) {
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler({ value, event }) {
      this.$emit('copyF', { value, event })
    },
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
    user() {
      return this.$store.state.user
    },

  }
}
</script>

<style>

</style>